module.exports = __webpack_public_path__ + "static/media/propose.e39b5a39.jpg";